import {
  SET_CONSULT_CASE_DATA,
  SET_CONSULT_ERROR_DATA,
  RESET_CONSULT_CASE_DATA,
  TOGGLE_CONSULT_LOADING,
} from 'redux/actions/actionTypes';

const initialState = {
  case: null,
  errorMsg: '',
  isLoading: false,
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_CONSULT_CASE_DATA: {
      return {
        ...state,
        case: payload,
      };
    }

    case TOGGLE_CONSULT_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case RESET_CONSULT_CASE_DATA: {
      return {
        ...initialState,
      };
    }

    case SET_CONSULT_ERROR_DATA: {
      return {
        ...state,
        errorMsg: payload,
      };
    }

    default:
      return state;
  }
};
